const conf = {
  // serverUrl: 'http://167.99.236.6:8082',
  // serverUrl: 'http://103.125.216.56:8094',
  serverUrl: 'https://service.b-low.com.au',
  basePath: 'api/v1',
  port: 80
};
export default conf;
